import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import { giveawayDeleteActionText } from 'Const/brief-live/view';
import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import { useModal } from 'Store/modal';

import deleteGiveaway from 'Api/brief-live/deleteGiveaway';

const useDeleteGiveaway = () => {
  const queryClient = useQueryClient();
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast, onResetToast } = useToast();
  const { onResetModal } = useModal();

  return useMutation({
    mutationFn: async (id) => {
      onShowLoader({ variant: 'loader-primary' });

      return await deleteGiveaway({ id });
    },
    onSuccess: () => {
      onResetToast();
      onResetModal();
      queryClient.invalidateQueries({ queryKey: ['giveaway-list'] });

      onOpenToast({
        status: 'success',
        description: giveawayDeleteActionText?.successDescription,
        duration: 5,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : giveawayDeleteActionText?.errorDescription;
      onResetToast();

      onOpenToast({
        status: 'error',
        title: giveawayDeleteActionText?.errorTitle,
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useDeleteGiveaway;
